jQuery(document).ready(function( $ ) {
    $( '.add-datepicker input.input-text').datepicker({
        dateFormat: 'dd-mm-yy',
        changeMonth:true,
        changeYear:true,
        minDate: new Date('1925-01-01'),
        maxDate: new Date('2050-12-31'),
        onSelect:function(date_text, inst){
            // change min age if needed (3 Years and 9 Months)
            var valid = $(this).validateAge(date_text, 3, 9, '-');
            if(valid) {
                // is 3,9
                $('.continue-checkout').css("display", "block");
            } else {
                // isn't 3,9
                $('.continue-checkout').css("display", "none");
            }
        }
    });
    jQuery.fn.extend({
        validateAge: function (birthday, years, months, separator) {
            if (!parseInt(years) && !parseInt(months)) {
                return false;
            }
            var label = years+' Years and '+months+' months';
            var split = birthday.split(separator);
            var year = split[2];
            var month = split[1];
            var day = split[0];

            var mydate = new Date();
            mydate.setFullYear(year, month-1, day);

            var currdate = new Date();
            currdate.setFullYear(currdate.getFullYear() - years);
            currdate.setMonth(currdate.getMonth() - months);

            console.log(currdate);
            console.log(mydate);

            if ((currdate - mydate) < 0){
                console.log("Sorry, only persons over the age of " + label + " may enter this site");
                return false;
            }
            return true;
        }
    });
});